import React, {Component} from "react";
import PropTypes from "prop-types";
import {translate, SelectInput} from "admin-on-rest";

export class NullableBooleanInput extends Component {
  state = {
    value: this.props.input.value
  };

  componentDidMount() {
    this.setState({value: this.props.input.value});
  }

  render() {
    const {
      input,
      meta,
      label,
      source,
      elStyle,
      resource,
      translate,
      labelStyle,
      inputStyle,
      floatingLabelStyle,
      underlineStyle,
      underlineFocusStyle,
      underlineShow,
      hintStyle
    } = this.props;

    if (this.state.value === true || this.state.value === false)
      this.props.input.value = this.state.value;

    return (
      <SelectInput
        input={input}
        label={label}
        source={source}
        resource={resource}
        choices={[
          {id: null, name: ""},
          {id: false, name: translate("aor.boolean.false")},
          {id: true, name: translate("aor.boolean.true")}
        ]}
        meta={meta}
        style={elStyle}
        options={{
          labelStyle: labelStyle,
          inputStyle: inputStyle,
          floatingLabelStyle: floatingLabelStyle,
          underlineStyle: underlineStyle,
          underlineFocusStyle: underlineFocusStyle,
          underlineShow: underlineShow,
          hintStyle: hintStyle
        }}
      />
    );
  }
}

NullableBooleanInput.propTypes = {
  addField: PropTypes.bool.isRequired,
  elStyle: PropTypes.object,
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  resource: PropTypes.string,
  source: PropTypes.string
};

NullableBooleanInput.defaultProps = {
  addField: true
};

export default translate(NullableBooleanInput);



// WEBPACK FOOTER //
// ./src/components/CRM/NullableBooleanInput.js